'use strict';

/*global isEmpty*/
/*global services*/

(function ($) {
  function Whisper($whisper, options) {
    this.options = options;
    this.$whisper = $whisper;
    this.$whisperWrapper = null;
    this.$whisperSearchResults = null;
    this.searchTimeout = null;
    this.searchDelay = 500; //v ms
    this.searchBlurTimeout = null;
    this.searchBlurDelay = 500; //v ms

    this.init();
  }

  Whisper.prototype = $.extend({}, {
    constructor: 'Whisper',

    registerCallbacks: function registerCallbacks() {
      var _this = this;

      _this.$whisperWrapper.on('keyup', 'input:text:focus', function () {
        _this.search($(this).val());
      });

      _this.$whisperWrapper.on('blur', 'input:text', function () {
        setTimeout(function () {
          _this.hideSearchResults();
        }, _this.searchBlurDelay);
      });

      _this.$whisperWrapper.on('click', '.whisper-search-result', function () {
        _this.setWhisperValue($(this));
        _this.hideSearchResults();
        return false;
      });
    },

    //----------------------------------------------------------------------------

    setWhisperValue: function ($btn) {
      var _this = this;

      var value = $btn ? $btn.data('value') : '';
      _this.$whisper.val(value);

      return _this;
    },

    showSearchResults: function ($results) {
      var _this = this;

      clearTimeout(_this.searchBlurTimeout);
      _this.$whisperSearchResults.html($results);
      _this.$whisperSearchResults.show();

      return _this;
    },

    hideSearchResults: function () {
      var _this = this;

      _this.$whisperSearchResults.hide();

      return _this;
    },

    search: function (searchString) {
      var _this = this;

      clearTimeout(_this.searchTimeout);

      _this.searchTimeout = setTimeout(function () {
        _this.doSearch(searchString);
      }, _this.searchDelay);

      return _this;
    },

    doSearch: function (searchString) {
      var _this = this;

      if (isEmpty(searchString)) {
        _this.setWhisperValue();
      }

      if (!isEmpty(searchString) || _this.options.searchEmptyString) {
        var url = _this.$whisper.data('url');

        $.get(url, { search_string: searchString }, function (res) {
          if (res.msg === 'SUCCESS') {
            _this.showSearchResults(res.data.html);
          } else {
            services.get('notifications').viewErrorMessage();
          }
        });
      } else {
        _this.hideSearchResults();
      }

      return _this;
    },

    //----------------------------------------------------------------------------

    init: function () {
      var _this = this;

      _this.$whisper.wrap('<div class="whisper-wrapper"></div>');
      _this.$whisperWrapper = _this.$whisper.closest('.whisper-wrapper');
      _this.$whisperSearchResults = $('<div>', { class: 'whisper-search-results' });
      _this.$whisperWrapper.append(_this.$whisperSearchResults);

      _this.registerCallbacks();

      return _this;
    }
  });

  var methods = {
    init: function (options) {
      var opts = $.extend({}, $.fn.k2_whisper.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('whisper-init')) {
          return;
        }

        $this.addClass('whisper-init');
        $this.data('whisper', new Whisper($this, opts));
      });
    }
  };

  $.fn.k2_whisper = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_whisper');
    }

  };

  $.fn.k2_whisper.defaults = {
    searchEmptyString: false
  };

})(jQuery);
